// Widget Scripts
import mainSlideshow from './js/widgets/mainSlideshow.js';
import autoEventFeed from './js/widgets/autoEventFeed.js';
import cardWidget from './js/widgets/cardWidget.js';
import hotButtons from './js/widgets/hotButtons.js';
import seoBlock from './js/widgets/seoBlock.js';
import photoGallery from './js/widgets/photoGallery.js';
import scrollerSponsors from './js/widgets/scrollerSponsors.js';
import popup from './js/widgets/popup';
import headerCustomButtons from './js/widgets/headerCustomButtons.js';
import customSignup from './js/widgets/customSignup.js';

// Custom Theme Scripts
import './js/localjs.js';
import MicroModal from 'micromodal';

// Initialize Homepage Widgets
$(document).ready(function () {
  headerCustomButtons('ticketButton', ticketButtonOpts);
  headerCustomButtons('headerButton', headerButtonOpts);

  if (globalThis.location.pathname === '/') {
    mainSlideshow();
    autoEventFeed();
    cardWidget('cardWidget', cardWidgetOpts, 3, 'Featured Events');
    hotButtons();
    seoBlock();
    cardWidget('cardWidget2', cardWidget2Opts, 4, 'Explore Venues');
    scrollerSponsors();
    photoGallery();
    customSignup();
    globalThis.addEventListener('load', function () {
      popup();
      MicroModal.init({
        awaitCloseAnimation: true,
      });
    });
  }
});
